import { render, staticRenderFns } from "./IssueCategoryEdit.vue?vue&type=template&id=032b713a&"
import script from "./IssueCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./IssueCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports